import React from "react";
import { FileText, User, Calendar, Plus } from "lucide-react";
import Button from "../../../../../components/button";
import { ButtonVariant } from "../../../../../shared/utils/enums";

interface ClinicalNote {
  id: string;
  date: string;
  provider: string;
  type: string;
  content: string;
}

const mockClinicalNotes: ClinicalNote[] = [
  {
    id: "1",
    date: "2024-03-15",
    provider: "Dr. Sarah Johnson",
    type: "Progress Note",
    content:
      "Patient reported improved sleep quality. Blood pressure remains stable. Continue current medication regimen.",
  },
  {
    id: "2",
    date: "2024-03-10",
    provider: "Dr. Michael Chen",
    type: "Assessment",
    content:
      "Initial assessment completed. Patient presents with mild symptoms. Recommended follow-up in 2 weeks.",
  },
  {
    id: "3",
    date: "2024-03-05",
    provider: "Dr. Emily Rodriguez",
    type: "Consultation",
    content:
      "Specialist consultation completed. Recommended additional diagnostic tests.",
  },
];

export const ClinicalNotesTab: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium dark:text-white">Clinical Notes</h2>
        <Button variant={ButtonVariant.PRIMARY}>
          <Plus className="h-4 w-4 mr-2" />
          Add Note
        </Button>
      </div>

      <div className="space-y-4">
        {mockClinicalNotes.map((note) => (
          <div
            key={note.id}
            className="bg-white dark:bg-darkCardBackground rounded-lg border border-gray-200 dark:border-gray-700 p-4"
          >
            <div className="flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 dark:text-white">
                    {note.type}
                  </h3>
                  <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
                    <User className="w-4 h-4" />
                    <span>{note.provider}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
                <Calendar className="w-4 h-4" />
                <span>{note.date}</span>
              </div>
            </div>
            <p className="mt-3 text-gray-600 dark:text-gray-300">
              {note.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
